import { render, staticRenderFns } from "./JobOpeningCard.vue?vue&type=template&id=b2f41a70&scoped=true"
import script from "./JobOpeningCard.vue?vue&type=script&lang=js"
export * from "./JobOpeningCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f41a70",
  null
  
)

export default component.exports